import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivateService } from "./activate.service";
import { Router } from "@angular/router";
import { ApiService } from '@bt/core';
import { Error } from "@bt/shared";
import { Validators, EmailValidator, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons"
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { BaseComponent } from "@bt/core/base";
import { NotifierService } from 'angular-notifier';

library.add(fas, far);
library.add(faCheckCircle);
library.add(faTimesCircle);
@Component({
  selector: 'app-activate',
  templateUrl: './activate.component.html',
  styleUrls: ["./activate.component.scss"]
})
export class ActivateComponent extends BaseComponent {
  public activationCode: string;
  public showLoader: boolean = false;
  public error: Error;
  public activateForm: FormGroup;
  public textError: string;
  constructor(private service: ActivateService,
    private apiService: ApiService,
    private router: Router,
    private fb: FormBuilder,
    private notifier:NotifierService) {
    super();
  }

  public activate(): void {
    var t = this;

      t.setLoading(true);
      this.apiService
        .putAnonym("api/users", {
          code: this.activationCode,
          sessionId: localStorage.getItem("activationSessionId")
          // sessionId: localStorage.getItem("sessionId")
        })
        .subscribe(
          (response) => {
          t.notifier.notify('success', 'Успешная активация аккаунта');
          this.router.navigateByUrl("app/login");
              t.setLoading(false);
          },
          (error: HttpErrorResponse) => {
            t.textError = error.error.errorMsgs[0];
            if (t.textError == "User not found") {
              t.textError = "Пользователь не найден"
            }
            else if(t.textError == "Code has been already used") {
              t.textError = "Код уже был использован"
            }
            else if(t.textError =="Invalid code")
            {
              t.textError ="Неверный код";
            }
            var alert = document.getElementsByClassName("myalert");
            (<any>alert[0]).style.display = "block";
            setTimeout(function () { (<any>alert[0]).style.display = "none"; }, 4000)
            t.setLoading(false);
          }
        );


  }

  get code() { return this.activateForm.get('code'); }

  public ngOnInit() {
    this.activateForm = this.fb.group({
      code: ["", [Validators.required, Validators.pattern(this.integerPattern),
      Validators.maxLength(6), Validators.minLength(6)]]
    });
    var urlParams = new URLSearchParams(window.location.search);
    localStorage.setItem("activationSessionId", urlParams.get("sessionId"));
    localStorage.setItem("activationCode", urlParams.get("code"));
    this.activationCode = urlParams.get("code");
    localStorage.setItem("activationUserId", urlParams.get("userId"));

    this.activate();
  }
}



// WEBPACK FOOTER //
// ./src/app/public/activate/activate.component.ts